import React, { FC } from 'react';
import Select from 'react-select/async';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { TagBoxControl, TagsBoxValueContainer } from './components/selectBoxControl';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { MultiValue } from './components/multiValueLabel';
import { bSearch } from '../../../core';

export type SelectBoxOption = any;

export interface SelectBoxProps {
    className?: string;
    labelName?: string;
    valueName?: string;
    placeholder?: string;
    options?: SelectBoxOption[];
    defaultOptions?: SelectBoxOption[];
    value?: SelectBoxOption[];
    onChange?: (value: SelectBoxOption[]) => void;
}

export const TagSearchBox: FC<SelectBoxProps> = (props) => {
    const { valueName, labelName, options, placeholder, onChange, value, className } = props;
    const getOptionValue = (option: SelectBoxOption): any => (valueName ? option[valueName] : option.identifier);
    const getOptionLabel = (option: SelectBoxOption): string => option[labelName ?? 'title'];

    return (
        <Select
            className={className}
            value={value ?? []}
            classNamePrefix="bg"
            placeholder={placeholder ?? 'Choose variant'}
            isMulti
            loadOptions={(inp) => {
                const items = bSearch.inArray(inp, labelName ?? 'title', options ?? []);
                return Promise.resolve(items.slice(0, 30));
            }}
            components={{
                Menu: OptionsBox,
                ValueContainer: TagsBoxValueContainer,
                IndicatorSeparator,
                DropdownIndicator: DropdownIndicatorBox,
                Option: OptionBox,
                MenuList: OptionsListBox,
                Control: TagBoxControl,
                MultiValue,
                NoOptionsMessage,
            }}
            defaultOptions={props.defaultOptions}
            isClearable={false}
            isSearchable={true}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            options={options ?? []}
            onChange={onChange as any}
        />
    );
};
import React, { FC } from 'react';
import Select from 'react-select/async';
import { NoOptionsMessage, OptionBox, OptionsBox, OptionsListBox } from './components/OptionsBox';
import { TagBoxControl, TagsBoxValueContainer } from './components/selectBoxControl';
import { IndicatorSeparator } from './components/IndicatorSeparator';
import { DropdownIndicatorBox } from './components/dropdownIndicatorBox';
import { MultiValue } from './components/multiValueLabel';
import { bSearch } from '../../../core';

export type SelectBoxOption = any;

export interface SelectBoxProps {
    className?: string;
    labelName?: string;
    valueName?: string;
    placeholder?: string;
    options?: SelectBoxOption[];
    defaultOptions?: SelectBoxOption[];
    value?: SelectBoxOption[];
    onChange?: (value: SelectBoxOption[]) => void;
}

export const TagSearchBox: FC<SelectBoxProps> = (props) => {
    const { valueName, labelName, options, placeholder, onChange, value, className } = props;
    const getOptionValue = (option: SelectBoxOption): any => (valueName ? option[valueName] : option.identifier);
    const getOptionLabel = (option: SelectBoxOption): string => option[labelName ?? 'title'];

    return (
        <Select
            className={className}
            value={value ?? []}
            classNamePrefix="bg"
            placeholder={placeholder ?? 'Choose variant'}
            isMulti
            loadOptions={(inp) => {
                const items = bSearch.inArray(inp, labelName ?? 'title', options ?? []);
                return Promise.resolve(items.slice(0, 30));
            }}
            components={{
                Menu: OptionsBox,
                ValueContainer: TagsBoxValueContainer,
                IndicatorSeparator,
                DropdownIndicator: DropdownIndicatorBox,
                Option: OptionBox,
                MenuList: OptionsListBox,
                Control: TagBoxControl,
                MultiValue,
                NoOptionsMessage,
            }}
            defaultOptions={props.defaultOptions}
            isClearable={false}
            isSearchable={true}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            options={options ?? []}
            onChange={onChange as any}
        />
    );
};
